import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@quorum/api';
import { AppointmentCaseQueryParameters } from '@quorum/models/xs-query';
import { AppointmentCase } from '@quorum/models/xs-resource';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'quorum-appointment-card-line-items-dialog',
  templateUrl: './appointment-card-line-items-dialog.component.html',
  styleUrls: ['./appointment-card-line-items-dialog.component.scss'],
})
export class AppointmentCardLineItemsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AppointmentCardLineItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { vehicleId: number; appointmentId: number },
    private apiService: ApiService
  ) {}
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  appointmentCases$: Observable<AppointmentCase[]>;

  ngOnInit(): void {
    const appointmentCaseQueryParameters: AppointmentCaseQueryParameters = new AppointmentCaseQueryParameters({
      appointmentId: this.data.appointmentId.toString(),
    });
    this.appointmentCases$ = this.apiService
      .get<AppointmentCase[]>('v/1/fixed-operations/appointment-cases', { params: appointmentCaseQueryParameters })
      .pipe(
        tap(() => {
          this.loading$.next(false);
        }),
        catchError(() => {
          this.loading$.next(false);
          return of({
            error: 'There was an error retrieving line items.',
          });
        })
      );
  }

  cancel() {
    this.dialogRef.close();
  }
}
